<section>
    @if ((isSearch$ | async) === false) {
        <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb>
    }
    @if ((isSearch$ | async) === true) {
        <app-breadcrumb [breadcrumbs]="breadcrumbsSearch"></app-breadcrumb>
    }
    <section>
        @if ((isSearch$ | async) === false) {
            <section>
                <app-products-categories [currentPage]="'products'" />
            </section>
        }
        <section>
            <app-products-listing />
        </section>
    </section>
</section>
